import React from 'react';
import { useState, useEffect } from 'react';
import DatePicker, { registerLocale } from "react-datepicker";
import { zhCN, enGB, enUS } from "date-fns/locale";

import useLocale from '../Utilities/useLocale';
import { useDateUtils } from '../Utilities/useDateUtils';
import "react-datepicker/dist/react-datepicker.css";
import "./DateTimePicker.css";

export interface DateTimePickerProps {
    name: string,
    dateTime: Date | null,
    dateOnly?: boolean,
    isClearable?: boolean,
    handleDateSelect: (date: Date | null) => void,
    required?: boolean,
    isInvalid?: boolean,
    showIcon?: boolean,
    inline?: boolean,
    className?: string,
    onClickOutside?:()=>void,
}

/**
 * @deprecated Please refactor to use the V2 DateTimePicker componenent
 * @param param0
 * @returns
 */
const DateTimePicker = ({ name, dateTime, handleDateSelect, isClearable = false, dateOnly = false, required = true, isInvalid = false, showIcon = true, inline = false, className, onClickOutside }: DateTimePickerProps) => {
    registerLocale('zh-CN', zhCN);
    registerLocale('en-GB', enGB);
    registerLocale('en-US', enUS);

    const localeCode: string | undefined = useLocale();
    const [locale, setLocale] = useState(enGB);
    var { getDatePickerFormat } = useDateUtils();

    useEffect(() => {
        if (!localeCode) {
            return;
        }

        switch (localeCode) {
            case "zh-CN":
                setLocale(zhCN);
                break;
            case "en-US":
                setLocale(enUS);
                break;
            default:
                setLocale(enGB);
                break;
        }
    }, [localeCode]);

    var { dateFormat, timeFormat } = getDatePickerFormat(dateOnly);

    return (
        <DatePicker
            name={name}
            selected={dateTime}
            onChange={(date: Date | null) => handleDateSelect(date)}
            className={`form-control${isInvalid ? ' is-invalid' : ''}`}
            showIcon={showIcon}
            toggleCalendarOnIconClick
            isClearable={isClearable}
            required={required}
            locale={locale}
            dateFormat={dateFormat}
            timeFormat={timeFormat}
            showTimeSelect={!dateOnly}
            timeIntervals={1}
            inline={inline}
            calendarClassName={inline ? "position-absolute" : undefined}
            onClickOutside={onClickOutside}
            wrapperClassName={`${isInvalid ? ' is-invalid' : ''}`} // Adding the bootstrap classes to the wrapper allow control.Feedbacks to work as expected
        />
    )
}

export default DateTimePicker